// Shared form layout primitives. One source of truth for the Section/Field
// pair that was previously copy-pasted (and drifting) across the form files.

export const Section = ({ title, description, children, grid = '1fr 1fr' }) => (
  <div style={{ marginBottom: '32px' }}>
    <div style={{ marginBottom: '16px' }}>
      <div style={{
        fontFamily: 'var(--font-sans)',
        fontSize: '11px', fontWeight: 500, color: 'var(--muted)',
        letterSpacing: '1.4px', textTransform: 'uppercase',
        marginBottom: description ? '4px' : 0,
      }}>{title}</div>
      {description && (
        <div style={{
          fontFamily: 'var(--font-sans)',
          fontSize: '13px', color: 'var(--muted-soft)',
        }}>{description}</div>
      )}
    </div>
    {grid ? (
      <div style={{
        display: 'grid', gridTemplateColumns: grid,
        columnGap: '16px', rowGap: '16px',
      }}>
        {children}
      </div>
    ) : children}
  </div>
);

// `required` shows the * marker; pair it with the `required` attribute on the
// input itself so the browser enforces it. `hint` renders muted helper text.
export const Field = ({ label, span = 1, required, hint, children }) => (
  <label style={{ gridColumn: `span ${span}`, display: 'flex', flexDirection: 'column' }}>
    <span style={{
      fontFamily: 'var(--font-sans)',
      fontSize: '12px', fontWeight: 500, color: 'var(--muted)',
      letterSpacing: '1.2px', textTransform: 'uppercase',
      marginBottom: '8px',
    }}>
      {label}
      {required && <span aria-hidden="true" style={{ color: 'var(--danger)', marginLeft: '3px' }}>*</span>}
    </span>
    {children}
    {hint && (
      <span style={{
        fontFamily: 'var(--font-sans)', fontSize: '12.5px', fontWeight: 400,
        color: 'var(--muted-soft)', marginTop: '6px', textTransform: 'none', letterSpacing: 0,
      }}>
        {hint}
      </span>
    )}
  </label>
);

// Placeholder shown inside a drawer or screen while an edit form fetches its
// record. Keeps the panel from sitting empty with no explanation.
export const FormLoading = ({ label = 'Loading…' }) => (
  <div aria-busy="true" style={{ padding: '8px 0 24px' }}>
    <div className="skeleton-line" style={{ width: '38%', marginBottom: '18px' }} />
    <div className="skeleton-line" style={{ width: '100%', height: '40px', marginBottom: '14px' }} />
    <div className="skeleton-line" style={{ width: '100%', height: '40px', marginBottom: '14px' }} />
    <div className="skeleton-line" style={{ width: '62%', height: '40px', marginBottom: '20px' }} />
    <div style={{
      fontFamily: 'var(--font-sans)', fontSize: '13px', color: 'var(--muted-soft)',
    }}>
      {label}
    </div>
  </div>
);
